import { FC } from 'react'
import { BookingType, TimelineView } from '../TimelineView'

// MeetingRoomType 인터페이스 정의
interface MeetingRoomType {
  id: string
  name: string
  capacity: number
  hasProjector?: boolean
  hasWifi?: boolean
  imageUrl?: string
  bookings: BookingType[]
}

// 아이콘 컴포넌트
const UsersIcon: FC = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="2"
    strokeLinecap="round"
    strokeLinejoin="round"
    className="h-4 w-4"
  >
    <path d="M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2" />
    <circle cx="9" cy="7" r="4" />
    <path d="M23 21v-2a4 4 0 0 0-3-3.87" />
    <path d="M16 3.13a4 4 0 0 1 0 7.75" />
  </svg>
)

const MonitorIcon: FC = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="2"
    strokeLinecap="round"
    strokeLinejoin="round"
    className="h-4 w-4"
  >
    <rect x="2" y="3" width="20" height="14" rx="2" />
    <line x1="8" x2="16" y1="21" y2="21" />
    <line x1="12" x2="12" y1="17" y2="21" />
  </svg>
)

const WifiIcon: FC = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="2"
    strokeLinecap="round"
    strokeLinejoin="round"
    className="h-4 w-4"
  >
    <path d="M5 12.55a11 11 0 0 1 14.08 0" />
    <path d="M1.42 9a16 16 0 0 1 21.16 0" />
    <path d="M8.53 16.11a6 6 0 0 1 6.95 0" />
    <line x1="12" y1="20" x2="12.01" y2="20" />
  </svg>
)

interface MeetingRoomProps {
  room: MeetingRoomType
  currentTime: number
}

export const MeetingRoom: FC<MeetingRoomProps> = ({ room, currentTime }) => {
  return (
    <div className="bg-white rounded-lg shadow overflow-hidden">
      <div className="flex flex-col md:flex-row">
        <div className="w-full md:w-1/4 p-4">
          <div className="relative h-40 md:h-full w-full rounded-lg overflow-hidden bg-gray-100 mb-4 md:mb-0">
            {room.imageUrl ? (
              <img
                src={room.imageUrl || '/placeholder.svg'}
                alt={room.name}
                className="object-cover w-full h-full"
                onError={(e) => {
                  e.currentTarget.src = '/placeholder.svg'
                }}
              />
            ) : (
              <div className="flex items-center justify-center h-full">
                <span className="text-gray-400">사진 없음</span>
              </div>
            )}
          </div>
        </div>
        <div className="w-full md:w-3/4 p-4">
          <div className="flex justify-between items-start mb-4">
            <div>
              <h2 className="text-xl font-bold">{room.name}</h2>
              <div className="flex items-center gap-4 text-sm text-gray-600 mt-2">
                <div className="flex items-center gap-1">
                  <UsersIcon />
                  <span>최대 {room.capacity}명</span>
                </div>
                {room.hasProjector && (
                  <div className="flex items-center gap-1">
                    <MonitorIcon />
                    <span>프로젝터</span>
                  </div>
                )}
                {room.hasWifi && (
                  <div className="flex items-center gap-1">
                    <WifiIcon />
                    <span>와이파이</span>
                  </div>
                )}
              </div>
            </div>
            <button
              className="bg-blue-600 text-white px-4 py-2 rounded-md hover:bg-blue-700 transition-colors"
              onClick={() => {
                // 예약 기능 구현 (향후 추가)
                alert(`${room.name} 예약 페이지로 이동합니다.`)
              }}
            >
              예약하기
            </button>
          </div>

          <TimelineView bookings={room.bookings} currentTime={currentTime} />
        </div>
      </div>
    </div>
  )
}
